import React, { useState, useEffect } from "react";
import { ArrowLeft, MapPin, Phone, Mail } from "lucide-react";
import { Button } from "./ui/button";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ContactPage = ({ onBack }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${API}/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error("Erreur:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-primary/10 sticky top-0 bg-background/95 backdrop-blur-sm z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Button
            data-testid="back-btn"
            variant="ghost"
            onClick={onBack}
            className="flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour
          </Button>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl text-street tracking-wide mb-4">
          Contactez-nous
        </h1>
        <p className="text-muted-foreground mb-12">
          Une question ? Besoin d'aide ? N'hésitez pas à nous contacter.
        </p>

        {loading ? (
          <div className="text-center py-12 text-muted-foreground">
            Chargement...
          </div>
        ) : settings ? (
          <div className="grid md:grid-cols-2 gap-8">
            {/* Contact Cards */}
            <div className="space-y-6">
              {settings.address && (
                <div className="glass-card rounded-lg p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <MapPin className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-bold mb-2">Adresse</h3>
                      <p className="text-muted-foreground text-sm">
                        {settings.address}<br />
                        {settings.postal_code} {settings.city}<br />
                        {settings.country}
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {settings.phone && (
                <div className="glass-card rounded-lg p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <Phone className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-bold mb-2">Téléphone</h3>
                      <a
                        href={`tel:${settings.phone}`}
                        className="text-primary hover:underline"
                      >
                        {settings.phone}
                      </a>
                    </div>
                  </div>
                </div>
              )}

              {settings.email && (
                <div className="glass-card rounded-lg p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                      <Mail className="w-6 h-6 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-bold mb-2">Email</h3>
                      <a
                        href={`mailto:${settings.email}`}
                        className="text-primary hover:underline"
                      >
                        {settings.email}
                      </a>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* About Section */}
            <div className="glass-card rounded-lg p-8">
              <h2 className="text-2xl font-bold mb-4">{settings.company_name || "TIKA"}</h2>
              <p className="text-muted-foreground leading-relaxed mb-6">
                Votre plateforme de billetterie pour les événements culturels Hip Hop, Afrobeat et RNB. 
                Nous célébrons et promouvons la culture urbaine en connectant artistes et fans.
              </p>
              <div className="pt-6 border-t border-border">
                <h3 className="font-bold mb-3">Horaires d'ouverture</h3>
                <p className="text-sm text-muted-foreground">
                  Lundi - Vendredi : 9h00 - 18h00<br />
                  Samedi : 10h00 - 16h00<br />
                  Dimanche : Fermé
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="glass-card rounded-lg p-8 text-center">
            <p className="text-muted-foreground">
              Les informations de contact ne sont pas encore disponibles.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};
